import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class UrlMixin extends Vue {
  public imagePath(fileName: string, directory?: string): string {
    if (directory) {
      return require(`@/assets/${directory}/${fileName}`);
    } else {
      return require(`@/assets/${fileName}`);
    }
  }
  public apiImagePath(filePath: string): string {
    return `${process.env.VUE_APP_MANAGE_BASE_URL}${filePath}`;
  }
}
